import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useUpdateFeatureSetting = ({ fetchSettings }) => {
  const navigate = useNavigate();
  const [isUpdating, setIsUpdating] = useState(false);

  const updateSetting = async (name, value) => {
    setIsUpdating(true);
    try {
      const token = localStorage.getItem("authToken");
      await axios.put(
        `/api/v1/admin/feature-settings/${name}`,
        { value },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      toast.success("Setting updated successfully!");
      fetchSettings();
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => navigate("/"), 1000);
        }
      }
    } finally {
      setIsUpdating(false);
    }
  };

  return { updateSetting, isUpdating };
};

export default useUpdateFeatureSetting;
